import React, { SVGProps } from 'react';
const expandMoreFilled = (props: SVGProps<SVGSVGElement>): JSX.Element => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 32" {...props}><path d="m10.547 11.453 6.12 6.107 6.12-6.107 1.88 1.88-8 8-8-8z" /></svg>;
export default expandMoreFilled;